module.exports = __webpack_public_path__ + "static/media/10euro.5f5f246c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/10euro.jpg
// module id = 928
// module chunks = 0